import { toast as rcToast, ToastContainer, ToastOptions, ToastPosition, cssTransition } from 'react-toastify';
import CustomToast from './CustomToast';
import 'react-toastify/dist/ReactToastify.css';
import './toastTransitions.css';

type ToastType = ToastOptions['type'];

const smoothFade = cssTransition({
  enter: 'smoothFadeIn',
  exit: 'smoothFadeOut',
  collapseDuration: 300,
});

const baseToast = (
  title: string,
  type: ToastType = 'default',
  options: ToastOptions = {}
) => {
  rcToast(<CustomToast title={title} type={type} />, {
    type,
    icon: false,
    hideProgressBar: true,
    closeButton: false,
    position: 'top-center' as ToastPosition,
    style: {
      background: 'transparent',
      boxShadow: 'none',
    },
    ...options,
  });
};

export const toast = {
  default: (title: string, options?: ToastOptions | number) =>
    baseToast(title, 'default', typeof options === 'number' ? { autoClose: options * 1000 } : options),
  success: (title: string, options?: ToastOptions | number) =>
    baseToast(title, 'success', typeof options === 'number' ? { autoClose: options * 1000 } : options),
  error: (title: string, options?: ToastOptions | number) =>
    baseToast(title, 'error', typeof options === 'number' ? { autoClose: options * 1000 } : options),
  info: (title: string, options?: ToastOptions | number) =>
    baseToast(title, 'info', typeof options === 'number' ? { autoClose: options * 1000 } : options),
  warning: (title: string, options?: ToastOptions | number) =>
    baseToast(title, 'warning', typeof options === 'number' ? { autoClose: options * 1000 } : options),
  dismiss: rcToast.dismiss,
  isActive: rcToast.isActive,
};

export const GlobalToastContainer = () => (
  <ToastContainer
    newestOnTop
    closeButton={false}
    toastClassName={() => 'bg-transparent shadow-none p-0'}
    bodyClassName={() => 'p-0 m-0'}
    transition={smoothFade}
    autoClose={3000}
    className="toast-container-custom"
    style={{
      '--toastify-toast-min-height': '64px',
    } as React.CSSProperties}
  />
);